import { DetailsCol, InfoTabs } from '@crm/components'
import { NotFound } from '@crm/components/Error'
import {
  OpportunityContext,
  OpportunityContextProvider
} from '@crm/contexts/OpportunityContext'
import { ConvertToClient } from '@crm/features/leads/components'
import { TitleSection } from '@shared/components'
import { useLocales } from '@shared/locales'
import { Button, Col, Row, Spin } from 'antd'
import { useContext, useState } from 'react'
import { useParams } from 'react-router-dom'

const LeadDetails = () => {
  const { t } = useLocales()
  const { lead, isLoading } = useContext(OpportunityContext)
  const [convertOpen, setConvertOpen] = useState(false)

  if (isLoading) {
    return <Spin />
  }

  return lead ? (
    <>
      <TitleSection title={`${t('contacts.lead')} / ${lead?.name || 'N/A'}`}>
        <Button type="primary" onClick={() => setConvertOpen(true)}>
          {t('lead.convert_to_client')}
        </Button>
      </TitleSection>

      {convertOpen && (
        <ConvertToClient
          open={convertOpen}
          leadId={lead.id}
          onClose={() => setConvertOpen(false)}
        />
      )}

      <Row gutter={10}>
        <Col span={10} md={8} xxl={6}>
          <DetailsCol />
        </Col>

        <Col span={14} md={16} xxl={18}>
          <InfoTabs />
        </Col>
      </Row>
    </>
  ) : (
    <NotFound />
  )
}

export const LeadsDetails = () => {
  const { id } = useParams()

  return (
    <OpportunityContextProvider id={id}>
      <LeadDetails />
    </OpportunityContextProvider>
  )
}
